export default __webpack_public_path__ + "static/media/coursera.f12eed9a.png";